export default {
  mounted(el, { value }) {
    el.setAttribute('data-focusable-error', value.toString());
  },
  updated(el, { value }) {
    el.setAttribute('data-focusable-error', value.toString());
  },
};
